import React from 'react';
import _ from 'lodash';

import { redirectTo } from 'src/utils/Http';
import { HOME_PAGE, DASHBOARD_SHOW, USER_LOGOUT } from 'src/constants/EndpointUrls';
import PayrollLogo from 'jbc-front/components/icons/PayrollLogo';
import JobcanHeader from 'jbc-front/components/JobcanHeader';
import CurrentUserInfo from './CurrentUserInfo';
import styles from './Header.scss';

class Header extends React.Component {
  // 共通IDヘッダを表示するか
  // - 従業員なしアカウントは、表示しない
  // - emailがない場合は、ログアウトされているため表示しない
  isShowJbcHeader(currentUser) {
    return !(_.isEmpty(currentUser) || !currentUser.hasEmployee || _.isEmpty(currentUser.email));
  }

  render() {
    const { isAuthorized, currentUser } = this.props;
    return (
      <React.Fragment>
        {this.isShowJbcHeader(currentUser) && (
          <JobcanHeader label="給与" user={currentUser.email} logout={() => redirectTo(USER_LOGOUT)} />
        )}
        <div className={styles.base}>
          <a href={isAuthorized ? DASHBOARD_SHOW : HOME_PAGE}>
            <PayrollLogo className={styles.BrandLogo} />
          </a>
          {isAuthorized && <CurrentUserInfo currentUser={currentUser} />}
        </div>
      </React.Fragment>
    );
  }
}
export default Header;
